/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   getCustomMessageByIntent
 */

import * as MessageC from '@zcode/nr/es/shared/constants/message'
import type { Listable, Property } from '@zcode/state-type'

const RANDOM_INDEX = Math.floor(Math.random() * Math.floor(5))

const getApplyIntentCustomMessage = ({ listingName }: Pick<Props, 'listingName'>) => {
  const listingText = listingName || 'your property'
  const FIRST_MESSAGE =
    "I'd like to apply for an apartment. What is your application process and/or requirements? Thanks!"
  const SECOND_MESSAGE =
    "Hi, I saw your listing on Zumper and I'm interested in moving in! What is your application process?"
  const THIRD_MESSAGE = `Can I request an application for ${listingText}? I'm interested in moving soon, thanks!`
  const FOURTH_MESSAGE =
    "Can you share your application process with me? I found your listing on Zumper and I'd like to apply!"
  const FIFTH_MESSAGE =
    "Hello, I'm interested in applying for a place. Can you please get in touch with your application details? Appreciate it!"

  const messageOptions = [
    FIRST_MESSAGE,
    SECOND_MESSAGE,
    THIRD_MESSAGE,
    FOURTH_MESSAGE,
    FIFTH_MESSAGE,
  ]
  const messageCopy = messageOptions[RANDOM_INDEX]

  return messageCopy
}

const getWaitlistIntentCustomMessage = () => {
  return 'I saw your property on Zumper. If you have a waitlist, can I join it?'
}

interface Props {
  intent?:
    | typeof MessageC.APPLY
    | typeof MessageC.MESSAGE
    | typeof MessageC.TOUR
    | typeof MessageC.WAITLIST
  listingName: (Listable | Property)['headerText']
}
interface TourProps {
  intent: typeof MessageC.TOUR
  listingName: (Listable | Property)['headerText']
}

export const getCustomMessagesByIntent = ({ intent, listingName }: Props | TourProps) => {
  if (intent === MessageC.APPLY) {
    return getApplyIntentCustomMessage({ listingName })
  }
  if (intent === MessageC.WAITLIST) {
    return getWaitlistIntentCustomMessage()
  }
  const messageEnd = intent === MessageC.TOUR ? 'take a tour' : 'learn more'
  return `I saw your rental listing on Zumper and would like to ${messageEnd}.`
}
